const StateEnum = {
  BANKING: 'banking',
  LEGAL_REPRESENTS: 'legal_represents',
  VOUCHERS: 'vouchers',
  COMPANY: 'company',
  FINAL: 'final_international',
};

export default StateEnum;
